import React, { useCallback } from "react";
import { Row, Col, Grid, Typography } from "antd";
import { useHistory } from "react-router-dom";
import styles from "./Header.module.css";
import _ from "lodash";

const { useBreakpoint } = Grid;

const Header = (props) => {
  const breakpoint = useBreakpoint();
  const history = useHistory();

  const wallet_address = localStorage.getItem("wallet_address");

  const logout = useCallback(() => {
    localStorage.removeItem("wallet_address");
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/tnc"
    ) {
      return;
    }
    window.location.href = "/";
  }, []);

  const backToHome = useCallback(() => {
    // localStorage.getItem("wallet_address") !== null
    //   ? history.push("/storing")
    //   : history.push("/");
    window.open("https://www.live4well.io/", "_blank");
  }, []);

  return (
    <div className={styles.header}>
      <Row className="boxContainer" align="middle" style={{ height: "100%" }}>
        <Col span={12}>
          <Row
            align="middle"
            style={{
              flexWrap: "nowrap",
              cursor: "pointer",
              width: "fit-content",
            }}
            onClick={backToHome}
          >
            <Col>
              <img
                src="/images/logo.png"
                alt=""
                style={{ width: 40, height: 40 }}
              />
            </Col>
            <Col>
              <div className={styles.title}>Live4Well</div>
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Row gutter={[breakpoint?.md ? 20 : 12]} justify="end" style={{flexWrap: "nowrap"}}>
            <Col>
              <div
                className={styles.iconBtn}
                onClick={() => {
                  window.open("https://discord.com/invite/live4well", "_blank");
                }}
              >
                <img
                  src="/images/discord.png"
                  alt=""
                  style={{ width: 20, height: 20 }}
                />
              </div>
            </Col>
            <Col>
              <div
                className={styles.iconBtn}
                onClick={() => {
                  window.open("https://twitter.com/live4well", "_blank");
                }}
              >
                <img
                  src="/images/twitter.png"
                  alt=""
                  style={{ width: 20, height: 20 }}
                />
              </div>
            </Col>
            {wallet_address !== null && (
              <Col>
                <div className={styles.button} onClick={logout}>
                  <div
                    className={styles.buttonText}
                    style={{ display: "flex", flexWrap: "nowrap" }}
                  >
                    {breakpoint?.md && `${wallet_address.slice(0, 6)}...${wallet_address.slice(
                      wallet_address.length - 4
                    )}`}
                    <img
                      src="/images/logout.png"
                      alt=""
                      style={{ width: 20, height: 20, marginLeft: breakpoint?.md ? 12 : 0 }}
                    />
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Header;
